// Hook
import { useMetricsReport } from '@shopee-user/real-time-metrics-report';

// Utils
import { getNativeDeviceFingerprint as baseGetNativeDeviceFingerprint } from '@shopee-user/shared-customization-logic';
import { isVersionReleased } from './version';

// Enums
import { Locale } from '@shopee-user/global';

// Constants
import { config } from '@shopee-user/platform';
import {
  VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP,
  VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP_VN,
} from '../constants/versionRelease';

// Types
import { WithFirebasePerformanceProps } from '@shopee-user-common/firebase-performance-utils';

const isVersionReleasedInLocale = (locale: Locale) => {
  if (locale === Locale.VN) {
    return isVersionReleased(VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP_VN);
  } else {
    return isVersionReleased(VERSION_RELEASE_ANDROID_WEB_BRIDGE_DFP);
  }
};

/** Gets App device fingerprint from webbridge.
 * Food Driver supports these commands: getDeviceFingerprint(Android) or getRiskToken(iOS).
 * For Food Driver, the min app version in ID/TH/MY = 6.43.0, VN = 12.2.0
 * If the command is not supported, getDeviceFingerprint will return with a maximum timeout of 100ms.
 *
 * FE TD: https://confluence.shopee.io/x/hBo6Xw
 * */

export const getNativeDeviceFingerprint = async ({
  recordFirebasePerformance,
  reportMetric,
  getNativeVersion,
  isReportMetricEnabled = false,
}: {
  recordFirebasePerformance?: WithFirebasePerformanceProps['recordFirebasePerformance'];
  reportMetric?: ReturnType<typeof useMetricsReport>['reportMetric'];
  getNativeVersion: () => string;
  isReportMetricEnabled?: boolean;
}) => {
  return baseGetNativeDeviceFingerprint({
    recordFirebasePerformance,
    reportMetric,
    getNativeVersion,
    isReportMetricEnabled,
    isAndroidAppVersionNotSupported: !isVersionReleasedInLocale(config.LOCALE),
  });
};
